<template>
  <div>
    <el-table :data="list" border style="width: 80%;margin-left:50px;">
      <el-table-column prop="account" label="账号"> </el-table-column>
      <el-table-column prop="body" label="套餐"> </el-table-column>
      <el-table-column v-if="flag" prop="money" label="返佣金额"> </el-table-column>
      <el-table-column prop="ordertime" label="下单时间"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getSubaccount();
  },
  computed:{
    flag(){
      return this.list.find(v=>v.money)?true:false
    }
  },
  methods: {
    async getSubaccount() {
      let uid = sessionStorage.getItem("uid");
      const res = await axios.post(
        "https://xlogin.us/api/my_order_list.php",
        qs.stringify({
          uid: uid,
        })
      );
      if(res.data.code === 200){
        this.list = res.data.data;
      }else{
        this.$message.error(res.data.msg)
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-table td{
  text-align: center;
}
 /deep/ .el-table th{
   background-color: #f5f7fa;
   text-align: center;
 }
</style>